export const OperatingCostsPermissions = {
  ViewandsearchinPropertyManagementOperatingCosts: {
    permissionsId: '0f4b4d2a-c8b4-4e37-c9cf-08d94f66fc61',
    permissionsName: 'View and search in  Property Management OperatingCosts',
    componentsId: null,
    components: null,
  },


  CreateOpertaingCosts: {
    components: null,
    componentsId: null,
    permissionsId: 'eb228f5f-46ae-4569-9325-08d967db92be',
    permissionsName: 'Create Opertaing Costs'
  },
  ViewAllPortfolio: {
    components: null,
    componentsId: null,
    permissionsId: '9dc05579-a92e-4ed2-9326-08d967db92be',
    permissionsName: 'View All portfolio'
  },

  ViewAllContacts: {
    components: null,
    componentsId: null,
    permissionsId: '44d46ddf-8831-43c7-9327-08d967db92be',
    permissionsName: 'View all contacts'
  },
  EditOperatingCosts: {
    components: null,
    componentsId: null,
    permissionsId: 'c9be20b0-89eb-4086-0be7-08d96d5117d1',
    permissionsName: 'Edit Operating Costs'
  },
  DeleteOperatingCost: {
    components: null,
    componentsId: null,
    permissionsId: '577330a9-e4d1-4b86-0be8-08d96d5117d1',
    permissionsName: 'Delete Operating Cost'
  }


};
